export function getStringMeta(
  metadata: Record<string, unknown> | undefined,
  key: string,
) {
  const v = metadata?.[key];
  return typeof v === "string" && v.trim() ? v : "";
}
